import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarePlanOption,
  CreateOptionValue,
  UpdateOptionValue,
} from '../options.model';

export interface OptionApi {
  listOptions(caseId: string): Observable<CarePlanOption[]>;
  createOption(
    caseId: string,
    value: CreateOptionValue,
  ): Observable<CarePlanOption>;
  updateOption(
    caseId: string,
    optionId: string,
    value: UpdateOptionValue,
  ): Observable<CarePlanOption>;
}

export const OPTION_API = new InjectionToken<OptionApi>('OPTION_API');
